import { nanoid } from 'nanoid';

const identify = (x: any) => ({
  ...x,
  id: x.id ?? `x${nanoid()}`,
});

export { identify };
